import { schema } from 'normalizr';

export const cardSchema = new schema.Entity('cards');
export const cardListSchema = [cardSchema];



// WEBPACK FOOTER //
// ./src/schemas/card.js